import { Image, Text } from '@user-portal/wikr-components';
import React from 'react';
import { Trans } from 'react-i18next';

import * as S from './styled';

const ExerciseItem = ({
    name,
    preview,
    time,
    onClick,
    isActive,
}: {
    name?: string;
    preview?: string;
    time?: number;
    onClick?: () => void;
    isActive?: boolean;
}) => {
    return (
        <S.Exercise onClick={onClick} $isActive={isActive}>
            {preview && (
                <S.ExerciseImage>
                    <Image alt={name ?? ''} src={preview} maxWidth={56} />
                </S.ExerciseImage>
            )}
            <S.ExerciseDescription>
                {name && (
                    <Text type="small-text" mb={4}>
                        {name}
                    </Text>
                )}
                <Text type="small-text" color="text-secondary">
                    <Trans i18nKey="workout.exercise.secs" values={{ time }} />
                </Text>
            </S.ExerciseDescription>
        </S.Exercise>
    );
};

export default ExerciseItem;
